import { Button } from '@/shared/ui/shadcn/button';
import { usePrescriptionCancellation, type CancellationTarget } from './model';
export function PrescriptionCancelButton({
  patientUserId,
  target,
  disabled = false,
  onCancelled,
  label = 'Cancel',
}: {
  patientUserId: string;
  target: CancellationTarget;
  disabled?: boolean;
  onCancelled?: () => void;
  label?: string;
}) {
  const { cancel, isPending } = usePrescriptionCancellation(patientUserId);
  return (
    <Button
      type="button"
      size="chip"
      className="bg-red-900 text-white hover:bg-red-900/90"
      disabled={disabled || isPending}
      aria-busy={isPending}
      onClick={() => {
        void cancel(target).then((accepted) => {
          if (accepted) {
            onCancelled?.();
          }
        });
      }}
    >
      {isPending ? 'Cancelling…' : label}
    </Button>
  );
}
